import axios from "axios";
import Config from "@/config"

export default class ApplianceService {
  getAppliances(accesstoken) {
    // if(Config.mock) {
    //   return axios
    //     .get(
    //       "stubs/get_appliances.json?t="+new Date().getTime(),
    //     )
    //     .then(res => res.data.body);
    // }
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .get(
        Config.proxy + Config.url("appliance") + "/appliances",
        options
      )
      .then(res => res.data.body);
  }
  getAppliance(accesstoken, serialNumber) {
    // if(Config.mock) {
    //   return axios
    //     .get(
    //       "stubs/get_appliance_details.json?t="+new Date().getTime(),
    //     )
    //     .then(res => res.data);
    // }
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .get(
        Config.proxy + Config.url("appliance") + "/appliances/"+serialNumber,
        options
      )
      .then(res => res.data);
  }
  postAppliance(accesstoken, data) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .post(
        Config.proxy + Config.url("appliance") + "/appliances", data,
        options
      )
      .then(res => res.data);
  }
  putAppliance(accesstoken, serialNumber, data) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .put(
        Config.proxy + Config.url("appliance") + "/appliances/"+serialNumber, data,
        options
      )
      .then(res => res.data);
  }
  deleteAppliance(accesstoken, serialNumber) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .delete(
        Config.proxy + Config.url("appliance") + "/appliances/"+serialNumber,
        options
      )
      .then(res => res.data);
  }
  getGammeByLab(accesstoken, labId) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .get(
        Config.proxy + Config.url("appliance") + "/lab/" + labId + "/gamma",
        options
      )
      .then(res => res.data.body);
  }
  getLabs(accesstoken) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .get(
        Config.proxy + Config.url("appliance") + "/labs",
        options
      )
      .then(res => res.data.body);
  }
  putLabs(accesstoken, id, data) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .put(
        Config.proxy + Config.url("appliance") + "/labs/" + id, data,
        options
      )
      .then(res => res.data.body);
  }
  postLabs(accesstoken, data) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .post(
        Config.proxy + Config.url("appliance") + "/labs", data,
        options
      )
      .then(res => res.data.body);
  }
  deleteLabs(accesstoken, labId) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .delete(
        Config.proxy + Config.url("appliance") + "/labs/"+labId,
        options
      )
      .then(res => res.data);
  }
  getAdminUsers(accesstoken) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .get(
        Config.proxy + Config.url("appliance") + "/admin/users",
        options
      )
      .then(res => res.data.body);
  }
  getAdminAppliances(accesstoken, email) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .get(
        Config.proxy + Config.url("appliance") + "/admin/appliances" + (email!=null?"?email=" + encodeURIComponent(email):""),
        options
      )
      .then(res => res.data.body);
  }
  postAdminShare(accesstoken, data) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .post(
        Config.proxy + Config.url("appliance") + "/admin/share", data,
        options
      )
      .then(res => res.data);
  }
  deleteAdminShare(accesstoken, email, serialNumber) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .delete(
        Config.proxy + Config.url("appliance") + "/admin/share?email=" + encodeURIComponent(email) + (serialNumber!=null?"&serialNumber="+serialNumber:""),
        options
      )
      .then(res => res.data);
  }
  getCommands(type) {
    return axios
      .get(
        "json/commands_"+type+".json",
      )
      .then(res => res.data);
  }
  getExtras(type) {
    return axios
      .get(
        "json/extras/extras_"+type+".json",
      )
      .then(res => res.data);
  }
  getFactoryAppliances(accesstoken, email) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .get(
        Config.proxy + Config.url("appliance") + "/factory/appliances" + (email!=null?"?email=" + encodeURIComponent(email):""),
        options
      )
      .then(res => res.data.body);
  }
  getFactoryAppliancesFilter(accesstoken, email, filters, pagination) {
    // if(Config.mock) {
    //   return axios
    //     .get(
    //       "stubs/get_factory_appliances.json?t="+new Date().getTime(),
    //     )
    //     .then(res => res.data.body);
    // }
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} },
    };
    let params = { 
      page: pagination?.first / pagination?.rows,
      nRows: pagination?.rows,
      filterAttributes: [],
      orderAttr: "serialNumber",
      ascOrDesc: true
    } 
    
    if(email) { params.filterAttributes.push({ "attribute": "email", "value": email }); }
    if(filters.global?.value) { params.filterAttributes.push({ "attribute": "serialNumber", "value": filters.global?.value }); }
    if(filters.domain?.value) { params.filterAttributes.push({ "attribute": "domain", "value": filters.domain?.value }); }
    if(filters.currentFirmware?.value) { params.filterAttributes.push({ "attribute": "currentFirmware", "value": filters.currentFirmware?.value }); }
    if(filters.online?.value) { params.filterAttributes.push({ "attribute": "online", "value": filters.online?.value }); }
    if(filters.modelNumber?.value) { 
      let model = filters.modelNumber?.value.split("|||");
      params.filterAttributes.push({ "attribute": "gamma", "value": model[0] }); 
      params.filterAttributes.push({ "attribute": "modelName", "value": model[1] }); 
    } else if(filters.gamma?.value) { 
      params.filterAttributes.push({ "attribute": "gamma", "value": filters.gamma?.value }); 
    }

    return axios
      .post(
        Config.proxy + Config.url("appliance") + "/factory/filter/appliance",
        params,
        options
      )
      .then(res => res.data.body);
  }
  getModelsForFilter(accesstoken, email) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .get(
        Config.proxy + Config.url("appliance") + "/factory/filter/model" + (email!=null?"?email=" + encodeURIComponent(email):""),
        options
      )
      .then(res => res.data.body);
  }
  getCurrentFirmwareForFilter(accesstoken, email) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .get(
        Config.proxy + Config.url("appliance") + "/factory/filter/currentFirmware" + (email!=null?"?email=" + encodeURIComponent(email):""),
        options
      )
      .then(res => res.data.body);
  }
  getDomainsForFilter(accesstoken, email) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .get(
        Config.proxy + Config.url("appliance") + "/factory/filter/domain" + (email!=null?"?email=" + encodeURIComponent(email):""),
        options
      )
      .then(res => res.data.body);
  }
  getFotaAppliances(accesstoken, email) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .get(
        Config.proxy + Config.url("appliance") + "/factory/update/appliances" + (email!=null?"?email=" + encodeURIComponent(email):""),
        options
      )
      .then(res => res.data.body);
  }
  postFactoryShare(accesstoken, data) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .post(
        Config.proxy + Config.url("appliance") + "/factory/share", data,
        options
      )
      .then(res => res.data.body);
  }
  deleteFactoryShare(accesstoken, email, serialNumber) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .delete(
        Config.proxy + Config.url("appliance") + "/factory/share?email=" + encodeURIComponent(email) + (serialNumber!=null?"&serialNumber="+serialNumber:""),
        options
      )
      .then(res => res.data.body);
    }
  getFotaModels(accesstoken) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .get(
        Config.proxy + Config.url("appliance") + "/factory/update/models",
        options
      )
      .then(res => res.data.body);
  }
  getFirmwareListByModel(accesstoken, modelId, brand, country) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .get(
        Config.proxy + Config.url("appliance") + "/factory/models/" + modelId + "/firmwares-list?" + (brand?"&brand="+brand:"") + (country?"&country="+country:""),
        options
      )
      .then(res => res.data.body);
  }
  getFirmwareListByAppliance(accesstoken, serialNumber) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .get(
        Config.proxy + Config.url("appliance") + "/factory/appliances/" + serialNumber + "/firmwares-list",
        options
      )
      .then(res => res.data.body);
  }
  updateFirmwareModel(accesstoken, modelId, firmwaresId, brand, country) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .post(
        Config.proxy + Config.url("appliance") + "/factory/models/" + modelId + "/update-firmware?forced=true&firmwareId=" + firmwaresId + (brand?"&brand="+brand:"") + (country?"&country="+country:""), null,
        options
      )
      .then(res => res.data);
  }
  updateFirmwareAppliance(accesstoken, serialNumber, firmwaresId) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .post(
        Config.proxy + Config.url("appliance") + "/factory/appliances/" + serialNumber + "/update-firmware?forced=true" + (firmwaresId?"&firmwareId="+firmwaresId:""), null,
        options
      )
      .then(res => res.data);
  }
  downloadCertificates(accesstoken, serialNumber) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} },
      responseType: 'blob'
    };
    return axios
      .get(
        Config.proxy + Config.url("appliance") + "/factory/appliances/" + serialNumber + "/certs",
        options
      )
      .then(res => res);
  }
  createAppliance(accesstoken, data) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} },
      responseType: 'blob'
    };
    return axios
      .post(
        Config.proxy + Config.url("appliance") + "/factory/appliances", data,
        options
      )
      .then(res => res);
  }
  getPassportUrl(accesstoken, serialNumber) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .get(
        Config.proxy + Config.url("appliance") + "/dpp-link/" + serialNumber,
        options
      )
      .then(res => res.data);
  }
  getApplianceEnergyList(accesstoken, startTimestamp, labIds, modelIds) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    let labIdsParam = "";
    if(labIds && labIds.length > 0) {
      labIdsParam = "&labId=" + labIds.join(",");
    }
    let modelIdsParam = "";
    if(modelIds && modelIds.length > 0) {
      modelIdsParam = "&modelId=" + modelIds.join(",");
    }
    return axios
      .get(
        Config.proxy + Config.url("appliance") + "/energy/appliances?startTimestamp=" + startTimestamp + labIdsParam + modelIdsParam,
        options
      )
      .then(res => res.data);
  }
  getApplianceEnergyDetail(accesstoken, serialNumber, startTimestamp) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .get(
        Config.proxy + Config.url("appliance") + "/energy/" + serialNumber + "?startTimestamp=" + startTimestamp,
        options
      )
      .then(res => res.data);
  }
  getEnergyChartGlobal(accesstoken, startTimestamp, labIds, modelIds) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    let labIdsParam = "";
    if(labIds && labIds.length > 0) {
      labIdsParam = "&labId=" + labIds.join(",");
    }
    let modelIdsParam = "";
    if(modelIds && modelIds.length > 0) {
      modelIdsParam = "&modelId=" + modelIds.join(",");
    }
    return axios
      .get(
        Config.proxy + Config.url("appliance") + "/energy/chart?startTimestamp=" + startTimestamp + labIdsParam + modelIdsParam,
        options
      )
      .then(res => res.data);
  }
  getEnergyChartSingle(accesstoken, serialNumber, startTimestamp) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .get(
        Config.proxy + Config.url("appliance") + "/energy/chart/" + serialNumber + "?startTimestamp=" + startTimestamp,
        options
      )
      .then(res => res.data);
  }
  putApplianceEnergyCost(accesstoken, serialNumber, cost, currency) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .put(
        Config.proxy + Config.url("appliance") + "/energy/cost/"+serialNumber+"?cost="+cost+"&currency="+currency, null,
        options
      )
      .then(res => res.data);
  }
  putApplianceAllEnergyCost(accesstoken, cost, currency) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .put(
        Config.proxy + Config.url("appliance") + "/energy/cost?cost="+cost+"&currency="+currency, null,
        options
      )
      .then(res => res.data);
  }
  patchHideAnomalies(accesstoken, serialNumber) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
    .patch(
      Config.proxy + Config.url("appliance") + "/anomalies/hide/" + serialNumber, null, 
      options
      )
      .then(res => res.data);
  }
  getFreviApplianceMovements(accesstoken, serialNumber) {
    // if(Config.mock) {
    //   return axios
    //     .get(
    //       "stubs/frevi_get_appliance_movements.json"
    //     )
    //     .then(res => res.data);
    // }
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .get(
        Config.proxy + Config.url("appliance") + "/appliances/" + serialNumber + "/movements",
        options
      )
      .then(res => res.data);
  }
}
